/**
 * Created by Administrator on 2018/1/3 0003.
 */
import axios from 'axios'
import qs from 'qs'
// eslint-disable-next-line
let ev = {
  devBaseUrl: 'https://uedapi.zto.com',
  proBaseUrl: 'https://uedapi.zto.com'
}
// let validateResponse = function (res) {
//   try {
//     if (res.status === false) {
//       alert(res.message)
//       throw new Error(res.message)
//     }
//   } catch (err) {
//     console.error(err)
//   }
// }
let defaults = {
  baseURL: process.ev.BASE_URL,
  timeout: 0,
  responseType: 'json',
  method: 'post',
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  },
  paramsSerializer: function (params) {
    return qs.stringify(params, {arrayFormat: 'brackets'})
  }
  // transformRequest: [function (data) {
  //   return qs.stringify(data)
  // }],
  // transformResponse: [function (data) {
  //   // ie 且 res为string类型 需手动格式化
  //   if (window.navigator.userAgent.includes('Trident') && (typeof data === 'string')) {
  //     data = JSON.parse(data)
  //   }
  //   validateResponse(data)
  //   return data
  // }]
}

Object.assign(axios.defaults, defaults)
export {
  axios
}



// WEBPACK FOOTER //
// ./src/config/axios.config.js